import { iceRelayRequired } from 'features/application/applicationSlice';
import { store } from 'store/store';
import { rememberRelayRequired } from 'utils/webrtc/relayRequiredStorage';

export const markRelayRequired = () => {
  rememberRelayRequired();
  store.dispatch(iceRelayRequired());
};
